import { useMutation } from '@tanstack/react-query';

import type {
  CreateClientAccessIntentData,
  CreateClientAccessIntentResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCreateClientAccessIntentMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: CreateClientAccessIntentData }) =>
      HttpClient.request<CreateClientAccessIntentResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });
